module.exports = __webpack_public_path__ + "media/backgrounds/bob-brewer-3yN9g6xAXkg-unsplash-dd6fbaa5.jpg";